var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCollapse(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "480.000000pt",
    height: "432.000000pt",
    viewBox: "0 0 480.000000 432.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,432.000000) scale(0.100000,-0.100000)",
    fill: "#BBC8D7",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M703 3710 c-95 -19 -184 -94 -219 -186 -18 -47 -19 -96 -19 -1474 0 -1161 2 -1433 13 -1469 19 -61 122 -164 183 -183 65 -19 2873 -19 2938 0 61 19 164 122 183 183 11 36 13 308 13 1469 0 1381 -1 1427 -19 1475 -25 65 -94 137 -159 166 l-52 24 -1410 2 c-775 0 -1429 -3 -1452 -7z m1927 -1660 l0 -1420 -940 0 c-927 0 -940 0 -960 20 -20 20 -20 33 -20 1393 0 754 3 1382 6 1394 3 12 13 24 23 26 9 3 438 5 954 6 l937 1 0 -1420z m900 1400 c20 -20 20 -29 18 -1409 -2 -764 -7 -1393 -11 -1398 -5 -4 -155 -9 -333 -11 l-324 -3 0 1421 0 1420 315 0 c302 0 316 -1 335 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1354 2661 c-39 -23 -68 -91 -58 -135 4 -23 63 -89 227 -254 l222 -222 -212 -213 c-116 -116 -216 -222 -222 -234 -40 -80 25 -173 122 -173 50 0 83 28 353 301 254 257 273 283 259 352 -6 24 -66 91 -259 286 -138 139 -271 266 -295 282 -52 34 -93 37 -137 10z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollapse);
export default __webpack_public_path__ + "static/media/collapse.56829b65f23cbba8c8bb57c5cb1afd93.svg";
export { ForwardRef as ReactComponent };